<template>
  <div>
    <v-row justify="center"
           class="mb-2"
           no-gutters>
      <v-col cols="11">
        <v-form ref="queryForm">
          <v-row justify="start" align="center">
            <v-col cols="2" xs="2">
              <z-source-selector label="报表类型"
                                 v-model="queryRequest.reportType"
                                 source="DicSelector" param="REPORT_TYPE"/>
            </v-col>
            <v-col cols="2" xs="2">
              <z-source-selector label="报表状态"
                                 v-model="queryRequest.reportStatus"
                                 source="DicSelector" param="REPORT_STATUS"/>
            </v-col>
            <v-col cols="2" class="pb-0 pr-0">
              <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="queryRequest.applyDateTime"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense
                                clearable
                                v-model="queryRequest.applyDateTime"
                                label="申请时间"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="queryRequest.applyDateTime" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu1 = false">取消</v-btn>
                  <v-btn text color="primary" @click="$refs.menu1.save(queryRequest.applyDateTime)">确定
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" xs="2">
              <v-text-field prepend-inner-icon="search" clearable label="申请人"
                            v-model="queryRequest.personName"/>
            </v-col>

            <v-col cols="3" xs="2">
              <v-btn small color="primary" :loading="loading" @click="query">
                搜索
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
              <v-btn small color="primary" class="ma-2" @click="resetQuery">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-form>
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center">
      <v-col :sm="11" :xs="12" cols="8">
        <v-data-table
            :headers="headers"
            :items="list"
            disable-sort
            :options.sync="options"
            :page.sync="queryRequest.pagedQueryInfo.index"
            :server-items-length="total"
            :loading="loading"
            :single-expand="false"
            item-key="index"
            :footer-props="footerOptions"
            :search="search">
          <template v-slot:item.opr="{ item }">
            <v-btn v-show="item.reportStatus == '02'" small color="primary" width="83px"
                   @click="downloadReport(item)">
              下载
            </v-btn>
          </template>
          <template v-slot:item.rate="{ item }">
            {{ item.rate }}%
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>


</template>

<script>
import {pageQuery, updateDownloadCount} from "@/api/ExportReport";
import {mapGetters} from "vuex"
import downloadReportExcel from "@/utils/reportDownLoad";

export default {
  name: "exportReportQueue",
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 50, 100, 200]
      },
      interval: undefined,
      loading: false,
      exportLoading: false,
      seniorQueryFlag: false,
      //请求参数
      menu1: false,
      queryRequest: {
        id: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        },
        reportType: '',
        personName: '',
        reportStatus: '',
        applyDateTime: '',
      },
      list: [],
      total: 0,
      headers: [
        {text: '报表类型', value: 'reportTypeDesc', align: 'center',},
        {text: '申请人', value: 'personName', align: 'center',},
        {text: '申请时间', value: 'applyDateTime', align: 'center',},
        {text: '报表状态', value: 'reportStatusDesc', align: 'center',},
        {text: '生成进度', value: 'rate', align: 'center',},
        {text: '下载次数', value: 'downloadCount', align: 'center',},
        {text: '操作', value: 'opr', align: 'center',},
        {text: ' ', value: 'data-table-expand', align: 'center',},
      ],
      options: {},
      search: '',


    }
  },
  watch: {
    options: {
      handler(val) {
        console.log(val)
        if (val.itemsPerPage == -1) {
          this.queryRequest.pagedQueryInfo.index = 1
          this.queryRequest.pagedQueryInfo.pageSize = 999999
        } else {
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        this.intervalFiveSecond()
      }
    }
  },
  computed: {
    ...mapGetters([
      "wmsMngFlag"
    ]),
  },
  methods: {
    extend() {
      this.seniorQueryFlag = !this.seniorQueryFlag;
    },
    //查询
    query() {
      this.queryRequest.pagedQueryInfo.index = 1;
      this.intervalFiveSecond();
    },
    //重置
    resetQuery() {
      this.$refs.queryForm.reset();
      this.queryRequest.id = '';
      this.query();
    },
    handleQuery() {
      // this.loading = true;
      pageQuery(this.queryRequest).then(res => {
        this.list = res.list;
        this.total = res.total;
        // this.loading = false
      }).catch(err => {
        // this.loading = false
      })
    },
    //5秒钟更新一次
    intervalFiveSecond() {
      this.handleQuery()
      clearInterval(this.interval)
      //定时任务
      this.interval = setInterval(() => {
        //查询展示数据
        this.handleQuery()
      }, 3000)
    },
    downloadReport(item) {
      let req = {
        id: item.id
      }
      updateDownloadCount(req).then(res => {
        downloadReportExcel(item.reportUrl);
        this.intervalFiveSecond()
      }).catch(err => {
      })
    },

  },
  created() {
    // const id = this.$route.query.id;
    // if (id) {
    //   this.queryRequest.id = id
    // }
    this.intervalFiveSecond();
    this.$store.dispatch('setCurretTitle', '下载队列');
  },
  mounted() {
  },
  destroyed() {
    clearInterval(this.interval)
    this.interval = null
  }
}
</script>

<style scoped>

</style>
